export const environment = {
    production: false,
    apiUrl: 'https://z3ecop7d3e.execute-api.us-west-2.amazonaws.com',
    anotherSetting: 'dev-value'
  };
  